import { render, staticRenderFns } from "./ActionChat.vue?vue&type=template&id=fbd563a8&"
import script from "./ActionChat.vue?vue&type=script&lang=js&"
export * from "./ActionChat.vue?vue&type=script&lang=js&"
import style0 from "./ActionChat.vue?vue&type=style&index=0&id=fbd563a8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports